export const FUTURE_CHANGES = [
  {
    id: 'fc-stikstof-2027',
    title: 'Aanscherping stikstofnormen',
    summary:
      'Verwachte aanscherping van stikstofdepositienormen nabij Natura 2000-gebieden. De kritische depositiewaarden (KDW) worden naar verwachting met 20-30% verlaagd, wat strengere eisen stelt aan bemesting en bedrijfsvoering.',
    status: 'verwacht',
    expectedDate: '2027',
    source: 'Ministerie van LNV',
    impact: 'high',
    link: 'https://www.rijksoverheid.nl/onderwerpen/stikstof',
    reason: 'Recente metingen van het RIVM tonen aan dat de stikstofdepositie op kwetsbare natuurgebieden nog steeds boven de kritische grenzen ligt, waardoor strengere normen nodig zijn.',
    relevance: {
      layers: ['natura2000'],
      crops: [],
      always: false,
    },
  },
  {
    id: 'fc-bufferstroken-2026',
    title: 'Verbreding bufferstroken langs watergangen',
    summary:
      'De verplichte bufferstrook langs watergangen wordt mogelijk verbreed van 3 naar 5 meter, in lijn met de Kaderrichtlijn Water (KRW). Dit heeft gevolgen voor het beschikbare teeltoppervlak van percelen langs watergangen.',
    status: 'consultatie',
    expectedDate: '2026',
    source: 'Ministerie van I&W',
    impact: 'high',
    link: 'https://www.helpdeskwater.nl/onderwerpen/wetgeving-beleid/kaderrichtlijn-water/',
    reason: 'Waterkwaliteitsmetingen laten zien dat huidige bufferstroken onvoldoende bescherming bieden tegen uitspoeling van nutriënten en gewasbeschermingsmiddelen naar oppervlaktewater.',
    relevance: {
      layers: ['buffer-zones', 'water'],
      crops: [],
      always: false,
    },
  },
  {
    id: 'fc-glb-eco-2027',
    title: 'Herziening GLB eco-regelingen',
    summary:
      'De eco-regelingen binnen het Gemeenschappelijk Landbouwbeleid (GLB) worden herzien voor de periode 2027-2032. Verwacht wordt dat de eisen voor deelname aan eco-regelingen worden aangescherpt en dat vergoedingen worden aangepast.',
    status: 'voorbereiding',
    expectedDate: '2027',
    source: 'Europese Commissie / RVO',
    impact: 'medium',
    link: 'https://www.rvo.nl/onderwerpen/glb',
    reason: 'De Europese Commissie evalueert het huidige GLB en concludeert dat de eco-regelingen onvoldoende bijdragen aan de klimaat- en biodiversiteitsdoelen.',
    relevance: {
      layers: [],
      crops: [],
      always: true,
    },
  },
  {
    id: 'fc-biodiversiteit-2026',
    title: 'Verplicht biodiversiteitsmonitorplan',
    summary:
      'Percelen nabij Natura 2000-gebieden met grasland krijgen mogelijk een verplichting tot het opstellen en uitvoeren van een biodiversiteitsmonitorplan. Dit omvat jaarlijkse inventarisatie van soorten en habitats.',
    status: 'consultatie',
    expectedDate: '2026',
    source: 'Ministerie van LNV',
    impact: 'medium',
    link: 'https://www.bij12.nl/onderwerpen/natuur-en-landschap/',
    reason: 'Uit natuurinventarisaties blijkt dat de biodiversiteit rond Natura 2000-gebieden sneller achteruitgaat dan verwacht, met name op aangrenzende landbouwgronden.',
    relevance: {
      layers: ['natura2000'],
      crops: ['Grasland'],
      always: false,
    },
  },
  {
    id: 'fc-neonicotinoiden-2026',
    title: 'Uitfasering neonicotinoïden',
    summary:
      'Het verbod op neonicotinoïde gewasbeschermingsmiddelen wordt naar verwachting uitgebreid naar alle open teelten. Dit raakt met name aardappel- en maïstelers die nu nog beperkt gebruik mogen maken van deze middelen.',
    status: 'verwacht',
    expectedDate: '2026',
    source: 'CTGB / EFSA',
    impact: 'medium',
    link: 'https://www.ctgb.nl',
    reason: 'Nieuwe EFSA-studies bevestigen dat neonicotinoïden ook bij beperkt gebruik schadelijk zijn voor bestuivers en bodemorganismen in open teelten.',
    relevance: {
      layers: [],
      crops: ['Aardappelen', 'Mais'],
      always: false,
    },
  },
  {
    id: 'fc-emissieregistratie-2028',
    title: 'Verplichte emissieregistratie gewasbescherming',
    summary:
      'Alle agrarische bedrijven worden naar verwachting verplicht om het gebruik van gewasbeschermingsmiddelen digitaal te registreren. Dit wordt gekoppeld aan het elektronisch logboek en is onderdeel van de Farm to Fork-strategie.',
    status: 'voorbereiding',
    expectedDate: '2028',
    source: 'Europese Commissie',
    impact: 'low',
    link: 'https://food.ec.europa.eu/plants/pesticides_en',
    reason: 'De Farm to Fork-strategie vereist volledige traceerbaarheid van gewasbeschermingsmiddelengebruik om de reductiedoelstelling van 50% in 2030 te kunnen monitoren.',
    relevance: {
      layers: [],
      crops: [],
      always: true,
    },
  },
  {
    id: 'fc-kdw-2028',
    title: 'Aanpassing KDW-systematiek',
    summary:
      'De berekeningssystematiek voor kritische depositiewaarden (KDW) wordt mogelijk herzien. Dit kan leiden tot gewijzigde stikstofruimte voor bedrijven nabij Natura 2000-gebieden.',
    status: 'onzeker',
    expectedDate: '2028',
    source: 'RIVM / Ministerie van LNV',
    impact: 'high',
    link: 'https://www.rivm.nl/stikstof',
    reason: 'Wetenschappelijk onderzoek wijst uit dat de huidige KDW-berekeningen bepaalde depositieroutes onderschatten, wat mogelijk leidt tot aanpassing van de systematiek.',
    relevance: {
      layers: ['natura2000'],
      crops: [],
      always: false,
    },
  },
  {
    id: 'fc-rustgewassen-2027',
    title: 'Verplichte rustgewassen in rotatie',
    summary:
      'Onder de nieuwe GLB-conditionaliteit wordt een verplicht aandeel rustgewassen in het bouwplan verwacht voor akkerbouwers. Minimaal 1 op 4 jaar een rustgewas op elk perceel.',
    status: 'consultatie',
    expectedDate: '2027',
    source: 'Ministerie van LNV',
    impact: 'medium',
    link: 'https://www.rvo.nl/onderwerpen/glb',
    reason: 'Bodemkwaliteitsonderzoeken tonen aan dat continue teelt van dezelfde gewassen leidt tot uitputting en verhoogde ziektedruk, wat de landbouwproductiviteit op termijn bedreigt.',
    relevance: {
      layers: [],
      crops: ['Aardappelen', 'Mais', 'Tarwe', 'Gerst', 'Suikerbieten', 'Uien'],
      always: false,
    },
  },
];

export const STATUS_LABELS = {
  voorbereiding: 'In voorbereiding',
  consultatie: 'Consultatie',
  verwacht: 'Verwacht',
  onzeker: 'Nog onzeker',
};

const IMPACT_ORDER = { high: 0, medium: 1, low: 2 };

export function matchFutureChanges(overlaps, cropName) {
  const overlapLayerIds = overlaps.map((o) => o.layerId);

  return FUTURE_CHANGES.map((change) => {
    let isRelevant = false;
    let relevanceReason = '';

    if (change.relevance.always) {
      isRelevant = true;
      relevanceReason = 'Alle percelen';
    }

    if (!isRelevant && change.relevance.layers.length > 0) {
      const matchedLayer = change.relevance.layers.find((l) => overlapLayerIds.includes(l));
      if (matchedLayer) {
        isRelevant = true;
        const layerNames = {
          natura2000: 'Natura 2000-overlap',
          'buffer-zones': 'Bufferzone watergang',
          water: 'Watergang',
        };
        relevanceReason = layerNames[matchedLayer] || matchedLayer;
      }
    }

    if (!isRelevant && change.relevance.crops.length > 0) {
      const matchedCrop = change.relevance.crops.find(
        (c) => cropName && cropName.toLowerCase().includes(c.toLowerCase()),
      );
      if (matchedCrop) {
        isRelevant = true;
        relevanceReason = `Gewastype: ${cropName}`;
      }
    }

    return { ...change, isRelevant, relevanceReason };
  }).sort((a, b) => {
    if (a.isRelevant !== b.isRelevant) return a.isRelevant ? -1 : 1;
    const impactDiff = IMPACT_ORDER[a.impact] - IMPACT_ORDER[b.impact];
    if (impactDiff !== 0) return impactDiff;
    return a.expectedDate.localeCompare(b.expectedDate);
  });
}
